import { render, staticRenderFns } from "./ObjectPageHeader.vue?vue&type=template&id=8abf231a&"
import script from "./ObjectPageHeader.vue?vue&type=script&lang=js&"
export * from "./ObjectPageHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports